import { Flex } from 'antd';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@shared/ui/antd';
import { ChannelTypeCards } from '../channel-type-cards/channel-type-cards';
import styles from './empty-state.module.scss';
import type { ChannelCreatableType } from '@modules/channels/lib/channel-type';

interface ChannelsEmptyStateProps {
  onSelectType: (type: ChannelCreatableType) => void;
}

export const ChannelsEmptyState: FC<ChannelsEmptyStateProps> = ({ onSelectType }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'channels' });

  return (
    <Flex vertical align="center" gap={24} className={styles.root}>
      <Text variant="xl" fontWeight={700} className={styles.title}>
        {t('emptyHeadline')}
      </Text>

      <ChannelTypeCards onSelect={onSelectType} />
    </Flex>
  );
};
